/* import { arrow } from "../assets";
import Company from "../layout/footer/components/Company"; */

const sendEmail = async (formData: any, isApplication: boolean, customTemplate?:string) => {
  const htmlTemplate = isApplication
    ? `
    <html>
      <head>
        <style>
          body {
            font-family: 'Arial', sans-serif;
            margin: 0;
            padding: 0;
            background-color: #f4f4f4;
          }
          .container {
            width: 60%;
            margin: auto;
            background-color: #ffffff;
            padding: 30px;
            border-radius: 10px;
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
            margin-top: 50px;
            margin-bottom: 50px;
            text-align: left;
          }
          .header {
            text-align: center;
            padding: 20px;
            border-bottom: 2px solid #3498db;
          }
          .header h1 {
            color: #3498db;
            font-size: 22px;
            margin-bottom: 5px;
          }
          .content {
            padding: 20px;
          }
          .content p {
            color: #333;
            line-height: 1.5;
            font-size: 16px;
          }
          .content strong {
            color: #2c3e50;
          }
          .details {
            background-color: #f9f9f9;
            padding: 15px;
            border-radius: 8px;
            margin-top: 15px;
          }
          .details p {
            margin: 5px 0;
            font-size: 16px;
          }
          .footer {
            text-align: center;
            padding: 15px;
            font-size: 14px;
            color: #888;
            border-top: 1px solid #ddd;
            margin-top: 20px;
          }
          .cta-button {
            display: inline-block;
            padding: 10px 20px;
            margin-top: 15px;
            background-color: #3498db;
            color: #ffffff;
            text-decoration: none;
            font-weight: bold;
            border-radius: 5px;
          }
        </style>
      </head>
      <body>
        <div class="container">
          <div class="header">
            <h1>New Applicant Submission</h1>
          </div>
          <div class="content">
            <p>Applicant Details</p>
            <div class="details">
              <p><strong>Name:</strong> ${formData.first_name} ${formData.last_name}</p>
              <p><strong>Phone:</strong> ${formData.phonbe_number}</p>
              <p><strong>Email:</strong> ${formData.email}</p>
              <p><strong>Experience:</strong> ${formData.experience}</p>
              <p><strong>Qualification:</strong> ${formData.degree}</p>
              <p><strong>SSLC Score:</strong> ${formData.X_mark}</p>
              <p><strong>HSC Score:</strong> ${formData.XII_mark}</p>
               <p><strong>College</strong> ${formData.college}</p>
                <p><strong>Degree</strong> ${formData.degree}</p>
                 <p><strong>Experience</strong> ${formData.experience}</p>
               <p><strong>Address:</strong> ${formData.address}</p>
               <p><strong>Country:</strong> ${formData.country}</p>
               <p><strong>Zipcode:</strong> ${formData.zipcode}</p>
            </div>
            <p>Please look through the resume in https://insytix.com/application</p>
            <a href="mailto:${formData.email}" class="cta-button">Contact Applicant</a>
          </div>
          <div class="footer">
            <p>This is an automated message. Please do not reply directly to this email.</p>
          </div>
        </div>
      </body>
    </html>
  `
    : null;

  const response = await fetch(
    "https://7ik9s2k445.execute-api.ap-south-1.amazonaws.com/sendemail",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: formData.name,
        message: formData.text,
        recipient: "apply@insytix.com",
        phone: formData.phoneNumber,
        email: formData.email,
        html_body: customTemplate ? customTemplate : htmlTemplate,
        to: ["development@insytix.com","HR@insytix.com","rajanm@insytix.com","vinothkumarr@insytix.com"],
        company_name: "INSYTIX - Website",
      }),
    }
  );
  return response;
};

export default sendEmail;

